import { render, staticRenderFns } from "./CardOffer.html?vue&type=template&id=1543e63a&scoped=true&"
import script from "./CardOffer.js?vue&type=script&lang=js&"
export * from "./CardOffer.js?vue&type=script&lang=js&"
import style0 from "./CardOffer.scss?vue&type=style&index=0&id=1543e63a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1543e63a",
  null
  
)

export default component.exports